
import { Component, Vue, } from 'vue-property-decorator'

@Component
export default class AppVersion extends Vue {
  private version = process.env.VUE_APP_VERSION
}
